"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
var CONSTANTS = {
  relatedDateFormat: 'dS mmmm yyyy, h:MM TT',
  UsersProducts: ['Cross-Cloud Capabilities', 'Adobe Campaign', 'Adobe Experience Manager', 'Adobe Audience Manager'],
  UserLanguage: 'en',
  EventTypeMapping: ['', 'MAJOR', 'MINOR', '', 'MAINTENANCE', 'DISCOVERY'],
  EventTypes: ['history', 'scheduledMaintenance']
};
var _default = CONSTANTS;
exports.default = _default;